import type { FormInstance } from "antd";
import { useTranslation } from "react-i18next";
import { CustomTypography } from "sipli-fleet-core/components";
import CustomerFormField from "../CustomerFormField";
import type { CustomerSelectLookups } from "../CustomerTabs";

const InterfaceDetails = ({
  form: _form,
  selectLookups,
}: {
  form: FormInstance;
  selectLookups: CustomerSelectLookups;
}) => {
  const { t } = useTranslation();

  return (
    <div className="mb-8">
      <CustomTypography.CustomTitle className="!text-[17px] !font-bold">
        {t("interface_details")}
      </CustomTypography.CustomTitle>
      <div className="grid grid-cols-2 mt-7 gap-x-3">
        <CustomerFormField
          name="currencyId"
          label={t("currency")}
          placeholder={t("select")}
          className="!h-[32px] !rounded-[4px]"
          options={selectLookups.currencyOptions}
          loading={selectLookups.currencyLoading}
        />
        <CustomerFormField
          name="distanceId"
          label={t("distance")}
          placeholder={t("select")}
          className="!h-[32px] !rounded-[4px]"
          options={selectLookups.distanceOptions}
          loading={selectLookups.distanceLoading}
        />
        <CustomerFormField
          name="volumeId"
          label={t("volume")}
          placeholder={t("select")}
          className="!h-[32px] !rounded-[4px]"
          options={selectLookups.volumeOptions}
          loading={selectLookups.volumeLoading}
        />
        <CustomerFormField
          name="temperatureId"
          label={t("temperature")}
          placeholder={t("select")}
          className="!h-[32px] !rounded-[4px]"
          options={selectLookups.temperatureOptions}
          loading={selectLookups.temperatureLoading}
        />
        <CustomerFormField
          name="weightId"
          label={t("weight")}
          placeholder={t("select")}
          className="!h-[32px] !rounded-[4px]"
          options={selectLookups.weightOptions}
          loading={selectLookups.weightLoading}
        />
        <CustomerFormField
          name="fuelConsumptionId"
          label={t("measurement_of_fuel_consumption")}
          placeholder={t("select")}
          className="!h-[32px] !rounded-[4px]"
          options={selectLookups.fuelOptions}
          loading={selectLookups.fuelLoading}
        />
        <CustomerFormField
          name="product"
          label={t("product")}
          placeholder={t("select_product")}
          className="!h-[32px] !rounded-[4px]"
          options={selectLookups.productOptions}
          loading={selectLookups.productLoading}
          disabled
        />
        <CustomerFormField
          name="price"
          label={t("price")}
          placeholder={t("type")}
          className="!h-[32px] !rounded-[4px]"
          type="number"
          disabled
        />
      </div>
    </div>
  );
};

export default InterfaceDetails;
